<template>
  <div>
    <c-eth-gas-option
      type="stake"
      :gasLimit="gasLimit"
      @update="updateGasPrices"
    >
      <div class="d-flex mt-16">
        <div>
          <div class="text-5 font-weight-medium">Migrate Amount</div>
          <div class="d-flex align-center mt-2 text-2">
            <div>
              <span class="primary--text">{{ bridgeAmount }}</span>
              <span class="gray--text text-uppercase ml-1">{{
                currentProject.staking.token
              }}</span>
            </div>
            <img
              :src="
                ($vuetify.theme.dark
                  ? currentProject.logoSmallDark
                  : currentProject.logoSmall) || currentProject.logoSmall
              "
              height="36"
              width="36"
              class="ml-4"
            />
          </div>
          <div class="mt-2 gray--text text-5">${{ stakeValue | currency }}</div>
        </div>
        <div class="ml-10">
          <div class="text-5 font-weight-medium ml-10">Transaction Fee</div>
          <div class="d-flex align-center mt-4 text-2">
            <v-divider vertical class="mr-10 border-stake"></v-divider>
            <div>
              <span class="primary--text">{{
                txFees.amount | denomFormat
              }}</span>
              <span class="gray--text text-uppercase ml-1">ETH</span>
            </div>
          </div>
          <div class="mt-2 gray--text text-5 ml-10">
            ${{ txFees.value | currency }}
          </div>
        </div>
      </div>
    </c-eth-gas-option>
    <div class="mt-16">
      <c-btn
        class="width-100"
        @click="confirm"
        :disabled="Number(rawTx.gas || 0) <= 0"
        >Confirm</c-btn
      >
    </div>
    <tx-ethereum
      v-if="showTxModal"
      title="Migrate"
      name="deposit"
      successMesssage="Transaction sent"
      broadcastAction="staking/dydx/broadcastTx"
      :walletAccount="secondaryWalletSelected"
      :txObject="txObject"
      :txFees="txFees"
      :metadata="{ amount: bridgeAmount, destAddr: walletSelected.address }"
      @cancel="showTxModal = false"
      @onSuccess="onTxSuccess"
    >
      <div class="d-flex mt-3">
        <div
          class="flex-2 text-left text-5 font-weight-medium text-uppercase gray--text"
        >
          Amount:
        </div>
        <div class="flex-3 text-3">
          {{ bridgeAmount }} {{ currentProject.staking.token | uppercase }}
        </div>
      </div>
    </tx-ethereum>
  </div>
</template>

<script>
import BN from "bignumber.js";
import { mapGetters } from "vuex";

export default {
  props: {
    bridgeAmount: String,
  },
  data: () => ({
    gasPrices: {},
    gasLimit: 0,
    rawTx: {},
    showTxModal: false,
  }),
  computed: {
    ...mapGetters({
      getTokenPriceInUsd: "appConfig/getTokenPriceInUsd",
      currentProject: "projectConfig/latestProject",
      walletSelected: "userWallets/walletSelected",
      secondaryWalletSelected: "userWallets/secondaryWalletSelected",
    }),
    stakeValue() {
      return (
        this.getTokenPriceInUsd(this.currentProject.staking.token) *
        this.bridgeAmount
      );
    },
    txFees() {
      const amount = new BN(this.gasPrices.gas || 0)
        .multipliedBy(this.gasPrices.maxFeePerGas || 0)
        .dividedBy(1e18)
        .toNumber();
      return {
        amount,
        value: amount * this.getTokenPriceInUsd("eth"),
      };
    },
    txObject() {
      return {
        ...this.rawTx,
        ...this.gasPrices,
      };
    },
  },
  methods: {
    updateGasPrices(prices) {
      this.gasPrices = prices;
    },
    async getRawTx() {
      const rawTx = await this.$store.dispatch("staking/dydx/getBridgeRawTx", {
        amount: this.bridgeAmount,
        destinationAddr: this.walletSelected.address,
      });
      this.gasLimit = rawTx.gas;
      this.rawTx = rawTx;
    },
    confirm() {
      this.showTxModal = true;
    },
    async onTxSuccess() {
      this.showTxModal = false;
      this.$router.replace({
        name: this.$route.name,
        params: this.$route.params,
      });
      this.$store.dispatch("staking/dydx/fetchRequiredInfo");
      this.$emit("close");
    },
  },
  mounted() {
    this.getRawTx();
  },
};
</script>
